module.exports = __webpack_public_path__ + "static/media/icon-close.77b6de5b.svg";